import { configureStore } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
import fetchProductsReducer  from '../features/fetchProuducts/fetchProductsSlice';
import fetchProductReducer from '../features/fetchProuducts/fetchProductSlice'
export const store = configureStore({
  reducer: {
    counter: counterReducer,
    fetchProducts: fetchProductsReducer,
    fetchProduct: fetchProductReducer,
  },
});
